import { ImageType, IPicture } from "./IPicture";

/**
 * Picture object
 * Base64Image - encoded image
 * OwnerGuid - guid of owner (coud be user, device etc..)
 * OwnerIdentity - custom identifier to recognise images within the same GUID (channels of device, profile image of user, etc...).
 */
export class Picture implements IPicture {
    protected _guid: string = "";
    protected _ownerGuid: string = "";
    protected _ownerIdentity: string = "";
    protected _base64Image: string = "";
    protected _imageType: ImageType = ImageType.Device;
    protected _dateTime: string = "";

    get Guid(): string {
        return this._guid;
    }
    get OwnerGuid(): string {
        return this._ownerGuid;
    }
    get OwnerIdentity(): string {
        return this._ownerIdentity;
    }
    get Base64Image(): string {
        return this._base64Image;
    }
    get ImageType(): ImageType {
        return this._imageType;
    }
    get DateTime(): string {
        return this._dateTime;
    }
    set Base64Image(value: string) {
        this._base64Image = value;
    }
    set Guid(value: string) {
        this._guid = value;
    }
    set OwnerGuid(value: string) {
        this._ownerGuid = value;
    }
    set OwnerIdentity(value: string) {
        this._ownerIdentity = value;
    }
    set ImageType(value: ImageType) {
        this._imageType = value;
    }
}